module.exports = __webpack_public_path__ + "static/img/qiweiCode.80b52b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/qiweiCode.png
// module id = d70/
// module chunks = 1